<template>
    <div v-if="view.is_active_affiliate" class='ba-alert ba-success'>
        <span>
            <b v-text="view.translations['label_congratulations_builder']"></b>
                {{ view.translations['notice_active_affiliate'] }}
        </span>
    </div>

    <div v-else-if="!view.user.office_configuracoes['deny_50_percent_off'] || view.user.office_configuracoes['deny_50_percent_off'] != 'SIM'" class='ba-alert ba-error'>
        <span>
            <b>{{ t.label_hey_builder }}</b>
            {{ t.notice_inactive_affiliate }}
        </span>
    </div>
</template>

<script>
    export default {
        name: 'fs5-earnings-notice',
        props: ['view', 't']
    }
</script>




// WEBPACK FOOTER //
// resources/office/js/components/franchise_v5/get_paid/user/notice/index.vue